import firebase from 'firebase'
import moment from 'moment'
import dayjs from 'dayjs'

var configs = {
  defaultConfig: {
    apiKey: 'AIzaSyA08KFgFlXQGqa6OfuL_yyzBQ7K9Ly98aI',
    authDomain: 'keyboardmaster-5b98e.firebaseapp.com',
    databaseURL: 'https://keyboardmaster-5b98e.firebaseio.com',
    projectId: 'keyboardmaster-5b98e',
    storageBucket: '',
    messagingSenderId: '591150152626',
    appId: '1:591150152626:web:d40aa539a9cf146a'
  },
  embeddedConfig: {
    apiKey: 'AIzaSyDnw04tA7e1lvhkqPSZaddHJxIbgRiD7xk',
    authDomain: 'keyboardmasterembedded.firebaseapp.com',
    databaseURL: 'https://keyboardmasterembedded.firebaseio.com',
    projectId: 'keyboardmasterembedded',
    storageBucket: 'keyboardmasterembedded.appspot.com',
    messagingSenderId: '775246462541',
    appId: '1:775246462541:web:ebc899c705b4bbb1c82604',
    measurementId: 'G-46MPFXN7CL'
  }
}

class FirebaseService {
  isReady = false
  isAuthValid = false // topで同実行中に2度の認証状態確認を行わないために使用
  isUserDataSyncFinished = false // topで同実行中に2度の個人データ同期を行わないために使用
  firebaseApp = null
  async init(type) {
    if (this.isReady === true) return
    const setting =
      type === 'embedded' ? configs['embeddedConfig'] : configs['defaultConfig']
    try {
      this.firebaseApp = await firebase.initializeApp(setting)
      this.isReady = true
    } catch (e) {
      console.log(e)
    }
  }
  signIn(email, password) {
    return new Promise((resolve, reject) => {
      this.firebaseApp
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(
          () => {
            this.firebaseApp
              .firestore()
              .collection('user_info')
              .doc(this.firebaseApp.auth().currentUser.uid)
              .get()
              .then(DocumentSnapshot => {
                const expirationDate = DocumentSnapshot.data().expirationDate // 有効期限(firestoreで保存されている日付)
                const now = dayjs(
                  this.firebaseApp.auth().currentUser.metadata.lastSignInTime
                ).format('YYYY/MM/DD') // 現在時刻(authの最終ログイン日)
                const dateAfter = dayjs(expirationDate).isAfter(dayjs(now)) // 有効期限前日まで(trueの場合はログイン出来る、falseの場合はログイン出来ない)
                const dateSame = dayjs(expirationDate).isSame(dayjs(now)) // 有効期限当日(trueの場合はログイン出来る、falseの場合はログイン出来ない)
                if (dateAfter || dateSame === true) {
                  const name = DocumentSnapshot.data().name
                  resolve({ name, email })
                } else {
                  alert(
                    'このアカウントの有効期限が切れています。継続利用される場合は、月々のお得な料金でご利用いただけます。まずはお問い合わせください。'
                  )
                  reject()
                }
                // console.log(expirationDate)
              })
              .catch(() => {
                // console.log(error)
                alert('データが正常に取得できません')
                reject()
              })
          },
          err => {
            switch (err.code) {
              case 'auth/user-not-found':
              case 'auth/invalid-email':
              case 'auth/wrong-password':
                alert('メールアドレスまたはパスワードが間違っています')
                break
              case 'auth/user-disabled':
                alert(
                  'アカウントは有効期限等の問題によりご利用が停止されています'
                )
                break
              case 'auth/network-request-failed':
                alert('ネットワークに問題が有ります')
                break
              default:
                alert('誤りがあります')
                break
            }
            reject()
          }
        )
    })
  }
  async validateAuth() {
    const user = await this.fetchCurrentUser()
    if (!user) {
      alert('エラー:認証確認に失敗しました')
      return false
    } else {
      const doc = await firebase
      .firestore()
      .collection('user_info')
      .doc(user.uid)
      .get()
      .catch(error => {
        console.log(error)
        alert('エラー:認証確認に失敗しました')
        return false
      })
      // 有効＆期限の確認
      const data = doc.data()
      const isValid =
        data.disabled === false &&
        moment().isSameOrBefore(moment(data.expirationDate))
      if (!isValid)
        alert('エラー:アカウントが無効になっているか有効期限切れになっています。')
      return isValid
    }
  }
  fetchCurrentUser() {
    return new Promise((resolve, reject) => {
      const unsubscribe = firebase.auth().onAuthStateChanged(user => {
        unsubscribe()
        resolve(user)
      }, reject)
    })
  }
}

export default new FirebaseService()
